jQuery(function ($) {
    function resizeMatchHeights(selector, container = null, unset = false) {
        var heightHolder = 0;
        $(selector).css('min-height', '0');
        if (container == null) {
             
            if (unset == false) {
                $(selector).each(function () {
                    if ($(this).innerHeight() > heightHolder) {
                        heightHolder = $(this).innerHeight();
                    }
                });
                $(selector).css('min-height', heightHolder + 'px');
            }

        } else {
            $(container).each(function(){
                var heightHolder = 0;
                if (unset == false) {
                    $(this).find(selector).each(function () {
                        console.log(container, $(this).innerHeight());
                        if ($(this).innerHeight() > heightHolder) {
                            heightHolder = $(this).innerHeight();
                        }
                    });
                    $(this).find(selector).css('min-height', heightHolder + 'px');
                }
             });
        }
    }


    $('a').each(function () {
        var a = new RegExp('/' + window.location.host + '/');
        if (!a.test(this.href)) {
            // This is an external link
            this.target = '_blank';
        }
    });
    // $(window).on('load', function () {
    //     $('.lottie-placeholder-image').each(function () {
    //         const lottie = $(this).data('lottie-url');
    //         console.log(lottie);
    //         $(this).replaceWith(`<dotlottie-player src="${lottie}" background="transparent" speed="1" loop="true" autoplay mode="normal" intermission="2000" renderer="canvas"></dotlottie-player>`);
    //     });
    // });

    $(window).on('scroll', function () {
        $(".underline, span[style*='text-decoration: underline;']").each(function () {
            if ($(this).is(':visible')) {
                $(this).addClass('visible');
            } // this is a very bad version of what i might want to do
        });
    });

    if ($('.linnworks-person-template-default').length > 0) {
        if ($('.linnworks-person-template-default .facetwp-template').children().length < 1) {
            $('.linnworks-person-template-default .related-posts').addClass('hidden');
        }
    }
    // if ($('.related-posts').length > 0) {
    //     $('.related-posts').each(function () {
    //         if ($(this).find('.search-results__content .facetwp-template').children().length < 1 && $(this).find('.related-posts__posts-container').children().length < 1) {
    //             $(this).addClass('hidden');
    //         }
    //     })
    // }
    if ($('#table-of-contents').length > 0) {
        const scrollSpy = new bootstrap.ScrollSpy(document.body, {
            target: '#table-of-contents',
            offset: 140,
            method: 'offset'
        })
    }

    $('.searchform-toggle, .searchform-overlay').on('click', function () {
        $('body').toggleClass('show-header-searchform');
        if ($('body').hasClass('show-header-searchform')) {
            $('.header-search-form-container .search-field').focus();
        }
    });




    $(document).on('facetwp-refresh', function () {
        if (FWP.soft_refresh == true) {
            FWP.enable_scroll = true;
        } else {
            FWP.enable_scroll = false;
        }
    });
    $(document).on('facetwp-loaded', function () {
        if (FWP.enable_scroll == true) {

            $('html, body').animate({
                scrollTop: ($('.search-results__content').offset().top
                    - 280)
            }, 500);
        }


        $('.search-filter').each(function () {
            items = $(this).find('.dropdown-menu');
            count = 0;
            checkboxes = $(items).find('.facetwp-checkbox');
            (checkboxes).each(function () {
                !$(this).hasClass('disabled') ? count += 1 : count += 0;
            });
            if (count == 0 && !$(this).hasClass('search-filter-product_family')) {
                $(this).addClass('disabled');
            } else {
                $(this).removeClass('disabled');
            }
        });

    });




   

    if ($('.boxshadow-icon-resize-group')) {
        $('.boxshadow-icon-resize-group').each( function () {
        // resizeMatchHeights('.boxshadow-icon-container');
        window.addEventListener("load", function() {
            resizeMatchHeights('.boxshadow-icon-text', '.boxshadow-icon-resize-group');
            
        });
        window.addEventListener('resize', function () {
            if ($(window).width() > 780) {
                resizeMatchHeights('.boxshadow-icon-text', '.boxshadow-icon-resize-group');
            } else {
                resizeMatchHeights('.boxshadow-icon-text', '.boxshadow-icon-resize-group', true);
            }
        });
    });
    } else if ($('.boxshadow-icon-text')) {

        // resizeMatchHeights('.boxshadow-icon-container');
        window.addEventListener("load", function() {
            resizeMatchHeights('.boxshadow-icon-text');

        });
        window.addEventListener('resize', function () {
            if ($(window).width() > 780) {
                resizeMatchHeights('.boxshadow-icon-text');
            } else {
                resizeMatchHeights('.boxshadow-icon-text', null, true);
            }
        });
    }


    // remove bottom padding from last .split-image-content if the real last child is a hidden geo restricted element.
    if ($('.wp-block-group>.split-image-content') && !$('.wp-block-group>.split-image-content:last').is(':visible')
    ) {
        $('.wp-block-group>.split-image-content:visible:last').css('padding-bottom', 0);
        //console.log('app.js line 70');
    }

    $(window).on('resize', function () {
        positionMobileUI();
    });
    function positionMobileUI() {
        //console.log('positionMobileUI');
        $('#mobile-header #mega-menu-primary').css('top', $('.sticky-header').outerHeight());
        $('.show-header-searchform #mobile-header .header-search-form-container').css('padding-top', 20 + $('.sticky-header').outerHeight());
    }

    positionMobileUI();

if ($('.linnworks-masterclass-slider').length > 0 && $('.skuvault-masterclass-slider').length > 0) {
    $('.skuvault-masterclass-slider').hide();
}

$('.show-linnworks').on('click', function() {
    $(this).addClass('active');
    $('.show-skuvault').removeClass('active');
    $('.skuvault-masterclass-slider').hide();
    $('.linnworks-masterclass-slider').show();

});
$('.show-skuvault').on('click', function() {

    $(this).addClass('active');
    $('.show-linnworks').removeClass('active');
    $('.skuvault-masterclass-slider').show();
    $('.skuvault-masterclass-slider .slick-slider').slick('refresh');
    $('.linnworks-masterclass-slider').hide();

});




})